import { createFileRoute } from '@tanstack/react-router';
import { AiWorkspaceLayout } from '@/components/ai/workspace';

export const Route = createFileRoute('/_app/ai')({ component: AiWorkspaceLayout });
